import { AxiosResponse } from 'axios';
import $api from '@/http/index';
import StatusCode from 'status-code-enum';
import { sendNotification } from '@molecules/Notifications';
import { INotification } from '@molecules/Notifications/INotification';

export class FilesService {
    static async downloadFile(
        url: string,
        noContentNotificationOptions?: INotification,
    ): Promise<void | AxiosResponse> {
        const file = await $api.get(`/${url}`, { responseType: 'blob' });
        this.checkAndDownload(file, noContentNotificationOptions);
    }

    static async downloadFilePost(
        url: string,
        data: any,
        config?: any,
        noContentNotificationOptions?: INotification,
    ): Promise<void> {
        config = {
            ...config,
            responseType: 'blob',
        };
        const file = await $api.post(`/${url}`, data, config);
        this.checkAndDownload(file, noContentNotificationOptions);
    }

    private static checkAndDownload(file: AxiosResponse<any>, noContentNotificationOptions?: INotification) {
        if (file.status === StatusCode.SuccessNoContent) {
            sendNotification(noContentNotificationOptions ?? { message: 'Файл не найден.', variant: 'red' });
            return;
        }
        this.download(file);
    }

    private static download(file: AxiosResponse<any>) {
        const url = window.URL.createObjectURL(
            new Blob([file.data], { type: file.headers['Content-Type']?.toString() ?? '' }),
        );
        let contentDisposition = file.headers['content-disposition'];
        let filename = this.getFileName(contentDisposition);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    private static getFileName(disposition: string): string {
        const utf8FilenameRegex = /filename([*]?)=UTF-8''([^\";]+)/i;
        const asciiFilenameRegex = /^filename=(["']?)(.*?[^\\])\1(?:; ?|$)/i;

        let fileName: string = '';
        if (utf8FilenameRegex.test(disposition)) {
            let match = utf8FilenameRegex.exec(disposition);
            if (match) {
                fileName = decodeURIComponent(match[2]);
            }
        } else {
            const filenameStart = disposition.toLowerCase().indexOf('filename=');
            if (filenameStart >= 0) {
                const partialDisposition = disposition.slice(filenameStart);
                const matches = asciiFilenameRegex.exec(partialDisposition);
                if (matches != null && matches[2]) {
                    fileName = matches[2];
                }
            }
        }
        return fileName;
    }
}
